import { useState, useEffect } from "react";
import Button from "./Button";
import { connect, useDispatch, useSelector } from "react-redux";
import { CLOSE_DIALOGUE } from "../store/dialogue/dialogue.type";
import { FormControl, TextField, MenuItem, Select } from "@mui/material";
import {
  createCategory,
  editCategory,
} from "../store/category/category.action";

const AddCategory = (props) => {
  const dispatch = useDispatch();
  const [categoryName, setCategoryName] = useState("");
  const [categoryStatus, setCategoryStatus] = useState(true);
  const [underSubmisson, setUnderSubmission] = useState(false);
  const [categoryNameError, setCategoryNameError] = useState("");

  const { dialogueType, dialogueData } = useSelector((state) => state.dialogue);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!categoryName) {
      setCategoryNameError("Category Name is required");
      return;
    }
    if (dialogueData) {
      const data = { categoryName, categoryStatus };
      setUnderSubmission(true);
      props.editCategory(data, dialogueData._id);
    } else {
      const data = { categoryName, categoryStatus };
      setUnderSubmission(true);
      props.createCategory(data);
    }
    setUnderSubmission(false);
    handleClose();
  };
  useEffect(() => {
    if (dialogueData) {
      setCategoryName(dialogueData?.categoryName);
      setCategoryStatus(dialogueData?.status);
    }
    // console.log(dialogueData)
  }, [dialogueData]);

  const handleClose = () => {
    dispatch({
      type: CLOSE_DIALOGUE,
      payload: {
        dialogue: false,
      },
    });

    let dialogueData_ = {
      dialogue: false,
    };
    localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };
  return (
    <>
      <div
        className="row search-action"
        style={{
          paddingRight: "3px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "16px",
        }}
      >
        <div className="col-12 col-lg-6 col-md-6 col-sm-12 ">
          <div
            className={`prime-input search-input-box  m-0`}
            sx={{
              borderRadius: "62px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{ fontSize: "25px", fontWeight: "500", color: "unset" }}
            >
              {dialogueData ? "Edit Category" : "Add Category"}
            </label>
          </div>

          <Button
            btnName={"Back"}
            newClass={"back-btn"}
            onClick={handleClose}
          />
          <form onSubmit={handleSubmit}>
            <FormControl
              sx={{
                m: 2,
                minWidth: 120,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <TextField
                id="outlined-basic"
                label="Category Name"
                variant="outlined"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                error={categoryNameError}
                sx={{
                  width: "100%",
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "9999px",
                    border: "none",
                    "& fieldset": {
                      // Target the outline
                      border: "none",
                    },
                    "&:hover fieldset": {
                      borderWidth: "1px",
                    },
                    "&.Mui-focused fieldset": {
                      borderWidth: "1px",
                    },
                  },
                }}
              />
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={categoryStatus}
                onChange={(e) => setCategoryStatus(e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  width: "100%",
                  borderRadius: "9999px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "9999px", // Make the input fully rounded
                    padding: "8px 16px", // Adjust padding for a better look
                  },
                  "& .MuiSelect-select": {
                    borderRadius: "9999px",
                  },
                }}
              >
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
              </Select>
              <Button
                newClass={"submit-btn-dialogue py-2"}
                type={"submit"}
                disabled={underSubmisson}
                btnName={dialogueData ? "Update" : "Create"}
                style={{ marginRight: "10px" }}
              />
            </FormControl>
          </form>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  createCategory,
  editCategory,
})(AddCategory);
